module.exports = __webpack_public_path__ + "img/flower_leaf_31.835666a2.png";